import { render, staticRenderFns } from "./admin-sitemap.vue?vue&type=template&id=85f415f8&"
import script from "./admin-sitemap.vue?vue&type=script&lang=js&"
export * from "./admin-sitemap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports